import { Size as ThemeSize } from './Spacing';
export const Spacing = ThemeSize.XSmall;
//# sourceMappingURL=Grid.js.map